/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePhysicalCountSessionDto } from '../models/CreatePhysicalCountSessionDto';
import type { PhysicalCountItemsListDto } from '../models/PhysicalCountItemsListDto';
import type { PhysicalCountParsePreviewResponseDto } from '../models/PhysicalCountParsePreviewResponseDto';
import type { PhysicalCountSessionSummaryDto } from '../models/PhysicalCountSessionSummaryDto';
import type { PhysicalCountUploadPreviewResponseDto } from '../models/PhysicalCountUploadPreviewResponseDto';
import type { ScanCodeDto } from '../models/ScanCodeDto';
import type { WriteOffMissingDto } from '../models/WriteOffMissingDto';
import type { WriteOffMissingResponseDto } from '../models/WriteOffMissingResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PhysicalCountService {
  /**
   * List physical count sessions with filters
   * @param code Filter by session code (partial)
   * @param locationId Filter by location ID
   * @param page Page number
   * @param limit Items per page
   * @returns any Paginated list of sessions
   * @throws ApiError
   */
  public static physicalCountControllerFindAll(
    code?: string,
    locationId?: number,
    page: number = 1,
    limit: number = 10,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/physical-count/sessions',
      query: {
        code: code,
        locationId: locationId,
        page: page,
        limit: limit,
      },
    });
  }
  /**
   * Create a new open physical count session
   * @param requestBody
   * @returns any Session created with status=open
   * @throws ApiError
   */
  public static physicalCountControllerCreate(
    requestBody: CreatePhysicalCountSessionDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/physical-count/sessions',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid location or date`,
      },
    });
  }
  /**
   * Get session summary without discrepancies or scans
   * @param id
   * @returns PhysicalCountSessionSummaryDto Session summary
   * @throws ApiError
   */
  public static physicalCountControllerFindSummary(
    id: number,
  ): CancelablePromise<PhysicalCountSessionSummaryDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/physical-count/sessions/{id}/summary',
      path: {
        id: id,
      },
      errors: {
        404: `Session not found`,
      },
    });
  }
  /**
   * Get paginated session items by category group
   * @param id
   * @param group Category of items to list
   * @param page
   * @param limit
   * @returns PhysicalCountItemsListDto Paginated items
   * @throws ApiError
   */
  public static physicalCountControllerFindItems(
    id: number,
    group: 'success' | 'missing' | 'excess' | 'scanned_not_available' | 'duplicate',
    page: number = 1,
    limit: number = 10,
  ): CancelablePromise<PhysicalCountItemsListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/physical-count/sessions/{id}/items',
      path: {
        id: id,
      },
      query: {
        group: group,
        page: page,
        limit: limit,
      },
      errors: {
        404: `Session not found`,
      },
    });
  }
  /**
   * Get session detail with discrepancies
   * @param id
   * @returns any Session detail
   * @throws ApiError
   */
  public static physicalCountControllerFindOne(id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/physical-count/sessions/{id}',
      path: {
        id: id,
      },
      errors: {
        404: `Session not found`,
      },
    });
  }
  /**
   * Parse and preview a scan file without persisting a session
   * @param formData
   * @returns PhysicalCountParsePreviewResponseDto
   * @throws ApiError
   */
  public static physicalCountControllerParsePreview(formData: {
    file: Blob;
    locationId: number;
    parseMode?: 'single_row' | 'single_column' | 'auto';
    normalization?: 'preserve_case' | 'uppercase';
  }): CancelablePromise<PhysicalCountParsePreviewResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/physical-count/parse-preview',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }
  /**
   * Atomically create a session, import scans from file, and finalize it
   * @param formData
   * @returns PhysicalCountSessionSummaryDto
   * @throws ApiError
   */
  public static physicalCountControllerImportAndFinalize(formData: {
    file: Blob;
    locationId: number;
    sessionDate: string;
    notes?: string;
    parseMode?: 'single_row' | 'single_column' | 'auto';
    normalization?: 'preserve_case' | 'uppercase';
  }): CancelablePromise<PhysicalCountSessionSummaryDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/physical-count/sessions/import-and-finalize',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }
  /**
   * Record a single barcode scan on an open session
   * @param id
   * @param requestBody
   * @returns any Scan recorded, returns result + progress
   * @throws ApiError
   */
  public static physicalCountControllerScanCode(
    id: number,
    requestBody: ScanCodeDto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/physical-count/sessions/{id}/scan',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Session not found`,
        409: `Session already finalized`,
      },
    });
  }
  /**
   * Upload scanned codes file for an open session and return comparison preview
   * @param id
   * @param formData
   * @returns PhysicalCountUploadPreviewResponseDto Upload parsed and preview computed successfully
   * @throws ApiError
   */
  public static physicalCountControllerUploadScansFile(
    id: number,
    formData: {
      file: Blob;
      parseMode?: 'single_row' | 'single_column' | 'auto';
      normalization?: 'preserve_case' | 'uppercase';
    },
  ): CancelablePromise<PhysicalCountUploadPreviewResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/physical-count/sessions/{id}/upload-scans',
      path: {
        id: id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }
  /**
   * Finalize an open session and compute discrepancy report
   * @param id
   * @returns any Session finalized with discrepancy report
   * @throws ApiError
   */
  public static physicalCountControllerFinalizeSession(id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/physical-count/sessions/{id}/finalize',
      path: {
        id: id,
      },
      errors: {
        404: `Session not found`,
        409: `Session already finalized`,
      },
    });
  }
  /**
   * Write off missing inventory pieces from a finalized session
   * @param id
   * @param requestBody
   * @returns WriteOffMissingResponseDto
   * @throws ApiError
   */
  public static physicalCountControllerWriteOffMissing(
    id: number,
    requestBody: WriteOffMissingDto,
  ): CancelablePromise<WriteOffMissingResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/physical-count/sessions/{id}/write-off-missing',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Invalid body or piece not available`,
        403: `Forbidden`,
        404: `Session or discrepancy not found`,
        409: `Session not finalized`,
      },
    });
  }
  /**
   * Export expected inventory for location (Excel)
   * @param locationId
   * @returns any Excel file — Scan Code | Product Code | Product Name | Status
   * @throws ApiError
   */
  public static physicalCountControllerExport(locationId: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/physical-count/export/{locationId}',
      path: {
        locationId: locationId,
      },
    });
  }
}
